<template>
  <el-popover
    v-if="showPopover"
    :ref="popoverRef"
    v-model="visible"
    :placement="placement"
    :visible-arrow="visibleArrow"
    @show="onPopoverShow"
  >
    <el-input v-model="areaValue" type="textarea" :rows="areaRows" :style="{width: areaWidth}" :placeholder="placeholder" />
    <div style="text-align: right; margin: 0">
      <el-button size="mini" type="text" @click="visible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      <el-button type="text" size="mini" @click="onAreaTextConfirm()">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
    </div>
    <el-input slot="reference" v-model="inputValue" :style="{width: inputWidth}" clearable :placeholder="placeholder" />
  </el-popover>
  <el-input v-else v-model="inputValue" :disabled="inputDisabled" :style="{width: inputWidth}" clearable :placeholder="placeholder" @keyup.enter.native.prevent="onInputEnter" />
</template>
<script>
export default {
  name: 'CargoMultiLineTextPopover',
  props: {
    placement: { type: String, default: 'top' },
    showPopover: { type: Boolean, default: false },
    popoverRef: { type: String, default: 'popover' },
    value: { type: String, default: '' },
    // Join/split delimiter between items in the underlying input value.
    // Default is comma to match existing "batch" behavior; can be overridden (e.g. '|').
    separator: { type: String, default: ',' },
    visibleArrow: { type: Boolean, default: true },
    inputWidth: { type: String, default: '100%' },
    areaWidth: { type: String, default: '200px' },
    areaRows: { type: Number, default: 5 },
    placeholder: { type: String, default: '' },
    inputDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      inputValue: '',
      areaValue: '',
      visible: false
    }
  },
  watch: {
    value(val) {
      this.inputValue = val
    },
    inputValue(val) {
      if (val) {
        this.areaValue = val.split(this.separator).join('\n')
      } else {
        this.areaValue = val
      }
      this.$emit('update:value', this.inputValue)
    }
  },
  created() {
    this.inputValue = this.value
  },
  methods: {
    onAreaTextConfirm() {
      this.inputValue = this.areaValue
        .split(/\n/)
        .map(item => (item || '').trim())
        .filter(item => item)
        .join(this.separator)
      this.visible = false
      this.$emit('update:value', this.inputValue)
    },
    onPopoverShow() {
      this.areaValue = this.inputValue.split(this.separator).join('\n')
    },
    onInputEnter(e) {
      this.$emit('inputEnter', e)
    }
  }
}
</script>
